module.exports = __webpack_public_path__ + "media/images/cardboard-img-02-6a42c7b3d7e3fbdf49b2a8a2f8641a9e.jpg";